import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      btnCancel: formatMessage(messages.btnCancel),
      btnSave: formatMessage(messages.btnSave),
    };
  }, [formatMessage]);

  return translations;
};
export default useTranslations;
